import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";

type Props = {
  to: string;
  name: string;
  /** Lo inyecta Trans: el nombre, ya traducido/interpolado */
  children?: ReactNode;
};

/** Link de la definition o policy con tooltip, porque la línea corta con ellipsis. */
export default function UsageLink({ to, name, children }: Props) {
  return (
    <Tooltip title={name}>
      <Link to={to} target="_blank">
        {children}
      </Link>
    </Tooltip>
  );
}
